import React from 'react';
import { createRoot } from 'react-dom/client';
import AllDistExports, { JoyDoc, JoyDocExporter } from '../dist/index';

function JoyDocBrowser(element, props) {
  const root = createRoot(element);
  root.render(React.createElement(JoyDoc, props));
}

function JoyDocExporterBrowser(element, props) {
  const root = createRoot(element);
  root.render(React.createElement(JoyDocExporter, props));
}

export default {
  ...AllDistExports,
  JoyDoc: JoyDocBrowser,
  JoyDocExporter: JoyDocExporterBrowser
};
